import { render, staticRenderFns } from "./ShippingRate.vue?vue&type=template&id=2a6d34b5&"
import script from "./ShippingRate.vue?vue&type=script&lang=js&"
export * from "./ShippingRate.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports